import React, { useCallback } from "react";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import StatsAPI from "@/src/api/StatsAPI";

import { contentCountriesQuery } from "./contentItem.queries";
import { buildContentCountriesMapData } from "./contentItem.utils";
import CountriesMapQueryCard from "../charts/CountriesMapQueryCard";

import type { JSX } from "react";

import type { GetContentCountriesResponse } from "@/src/api/StatsAPI.types";
import type { AppState } from "@/src/reducers";

import type { ContentItemPeriodProps } from "./contentItem.types";

function ContentCountriesMapCard({
  contentId,
  period,
}: ContentItemPeriodProps): JSX.Element {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { t } = useTranslation("editor-analytics");
  const countries = useSelector(
    (state: AppState) => state.fetchReducer.countries,
  );

  const buildValueByCountry = useCallback(
    (response: GetContentCountriesResponse | undefined) =>
      buildContentCountriesMapData(response, countries),
    [countries],
  );
  const fetchCsv = async (): Promise<BlobPart> =>
    StatsAPI.getContentCountries({
      contentId,
      projectSlug,
      startDate: period.startDate,
      endDate: period.endDate,
      isExport: true,
    });

  return (
    <CountriesMapQueryCard
      buildValueByCountry={buildValueByCountry}
      csvExport={{ fetchCsv, fileName: "countries.csv" }}
      query={contentCountriesQuery(projectSlug, contentId, period)}
      title={t("contentItem.charts.countries")}
      valueLabel={t("charts.series.views")}
    />
  );
}

export default ContentCountriesMapCard;
